import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseBrand } from '@/shared/converters/brandConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseOutlet } from '@/shared/converters/outletConverters';
import BookingItem from '../models/BookingItem';

const SCHEMA = {
  ...BASE_SCHEMA,
  id: 'id',
  language: 'language',
  type: 'type',
  outlet: (data: any) => parseOutlet(data.outlet),
  brand: (data: any) => parseBrand(data.brand),
  description: (data: any) => data.description || data.shortDescription,
  longDescription: 'longDescription',
  code: 'code',
  operationCode: 'operationCode',
  price: 'price',
  laborMinutes: 'laborTime',
  isDeleted: 'isDeleted',
  isMaintenance: 'isMaintenance',
  isB2CVisible: 'isB2CVisible',
  isQuoteItem: 'isQuoteItem',
  validFrom: (data: any) => parseMoment(data.validFrom),
  validTill: (data: any) => parseMoment(data.validTill),
};

export function parseBookingItem(data: any): BookingItem | null {
  return parseEntity(data, SCHEMA, BookingItem);
}

export function parseBookingItems(data: any): Array<BookingItem> {
  return parseEntities(data, parseBookingItem);
}
